export default {
    props: {
        rowData:  {
            type:     Object,
            required: true
        },
        rowIndex: {
            type: Number
        }
    },

    data() {
        return {
            submitting:             false,
            apiUrl:                 null,
            forceReloadAfterSubmit: false
        };
    },

    methods: {
        prepareUpdateData() {
            throw 'Not implemented! You must do that yourself!';
        },

        submit(options = {multiForm: false}) {
            if (this.submitting)
                return;

            let data = this.prepareUpdateData();

            if (!options.multiForm && Object.keys(data).length === 0)
                return;

            this.$set(this, 'submitting', true);

            if (options.multiForm) {
                data.append('_method', 'PUT');
            }

            axios[options.multiForm ? 'post' : 'put'](`${this.apiUrl}/${this.rowData.id}`, data, options)
                .then(response => {
                    this.$set(this, 'submitting', false);

                    if (this.forceReloadAfterSubmit) {
                        this.$events.fire('refreshTableData');
                    }

                    this.$toast.success({
                        title:   'USPEH!',
                        message: response.data.message
                    });
                })
                .catch(error => {
                    this.$set(this, 'submitting', false);

                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    } else {
                        this.$toast.error({
                            title:   'NAPAKA!',
                            message: error.response.data.message,
                            timeOut: 10000
                        });
                    }
                });
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/TableDetails.js